<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-5 col-xl-5 col-xxl-4 bg-white rounded shadow-5-strong p-2">
          <form class="pb-0 px-3 pt-2 border-out rounded">
              <div class="d-flex justify-content-center" >
                <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                  <img [src]="logoUrl" alt="IEA logo" class="logo" />
                </div>
              </div>
            <div class="p-0 m-0" id="logindiv">
              <div class="login-form-container m-0">
                <form class="login-container shadow">
                  <div class="title-container">
                    <div class="login-container shadow login-form-container">
                      <div class="m-0">
                        <h2 class="text-center mt-2 mb-0 pb-0">{{headerLabel}}</h2>
                        <hr class="mt-1 pt-0 mb-1">
                      </div>
                      <div *ngIf="appName == 'arenaEqApp'" >
                        <form [formGroup]="emailLoginForm" class="login-container shadow mt-4">
                          <div class="inputs-container">
                            <div class="field">
                              <eq-email [form]="emailLoginForm" [name]="'email'" [label]="'Email Address'"
                                [validators]="emailValidator" class=""></eq-email>

                            </div>
                            <div class="field">
                              <eq-password [label]="'Password'" [form]="emailLoginForm" [name]="'passWord'"
                                [validators]="passWordValidator" class=""></eq-password>
                            </div>

                            <div class="col-md-12 text-center">
                              <button mat-raised-button color="primary"
                                class="text-center btn btn-primary btn-block w-100 py-2"
                                [disabled]="!emailLoginForm.valid" (click)="loginWithEmail('email')">
                                SIGN IN
                              </button>
                            </div>
                            <div (click)="goToPage(passwordResetUrl)" class="options-container text-center mt-2 mb-0">
                              <a class="password-recovery">Forgot Password?</a>
                            </div>
                            <div class="col-12">
                              <div class="row justify-content-center">
                                <div class="col-4">
                                  <hr />
                                </div>
                                <div class="col-1">
                                  <p class="text-center pt-2">OR</p>
                                </div>
                                <div class="col-4">
                                  <hr />
                                </div>
                              </div>
                              <div class="col-12">
                                <p class="text-center pt-2">Need to create a new account?</p>
                              </div>
                              <button (click)="goToPage(signUpUrl)" type="button" class="btn btn-Sign-in btn-block w-100 py-2">
                                <a class="password-recovery">SIGN UP</a>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" *ngIf="appName == 'ieaApp'">
                        <mat-tab label="Adult Login">
                          <form [formGroup]="emailLoginForm" class="login-container shadow mt-4">
                            <div class="inputs-container">
                              <div class="field">
                                <eq-email [form]="emailLoginForm" [name]="'email'" [label]="'Email Address'"
                                  [validators]="emailValidator" class=""></eq-email>

                              </div>
                              <div class="field">
                                <eq-password [label]="'Password'" [form]="emailLoginForm" [name]="'passWord'"
                                  [validators]="passWordValidator" class=""></eq-password>
                              </div>

                              <div class="col-md-12 text-center">
                                <button mat-raised-button color="primary"
                                  class="text-center btn btn-primary btn-block w-100 py-2"
                                  [disabled]="!emailLoginForm.valid" (click)="loginWithEmail('email')">
                                  SIGN IN
                                </button>
                              </div>
                              <div (click)="goToPage(passwordResetUrl)" class="options-container text-center mt-2 mb-0">
                                <a class="password-recovery">Forgot Password?</a>
                              </div>
                              <div class="col-12">
                                <div class="line-with-text">
                                  <hr>
                                  <div class="text">OR</div>
                                </div>
                                <div class="col-12">
                                  <p class="text-center pt-2">Need to create a new account?</p>
                                </div>
                                <button (click)="goToPage(signUpUrl)" type="button" class="btn btn-Sign-in btn-block w-100 py-2">
                                  <a class="password-recovery">SIGN UP</a>
                                </button>
                              </div>
                            </div>
                          </form>
                        </mat-tab>
                        <mat-tab label="Youth Login">

                          <form [formGroup]="usernameLoginForm" class="login-container shadow  mt-4">
                            <div class="inputs-container shadow">
                              <div class="field">
                                <eq-textInput [form]="usernameLoginForm" [name]="'username'" [label]="'Username'"
                                  [validators]="userNameValidator" class=""
                                  [icon]="'person'"><mat-icon>person</mat-icon>
                                </eq-textInput>

                              </div>
                              <div class="field">
                                <eq-password [label]="'Password'" [form]="usernameLoginForm" [name]="'passWord'"
                                  [validators]="passWordValidator" class=""></eq-password>
                              </div>

                              <div class="col-md-12 text-center">
                                <button mat-raised-button color="primary"
                                  class="text-center btn btn-primary btn-block w-100 py-2"
                                  [disabled]="!usernameLoginForm.valid" (click)="loginWithUserName('username')">
                                  SIGN IN
                                </button>
                              </div>
                              <div (click)="goToPage(passwordResetUrl)" class="options-container text-center mt-2 mb-0">
                                <a class="password-recovery">Forgot Password?</a>
                              </div>
                              <div class="col-12">
                                <div class="line-with-text">
                                  <hr>
                                  <div class="text">OR</div>
                                </div>
                                <div class="col-12">
                                  <p class="text-center pt-2">Need to create a new account?</p>
                                </div>
                                <button type="button" (click)="goToPage(signUpUrl)" class="btn btn-Sign-in btn-block w-100 py-2">
                                  <a class="password-recovery">SIGN UP</a>
                                </button>
                              </div>
                            </div>
                          </form>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                    <div class="col-12 text-center mt-3 mb-0 pb-0">
                      <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png"
                        alt="IEA logo" />
                    </div>
                    <div class="col-12 text-center mt-3 mb-0 pb-1" *ngIf="appName == 'arenaEqApp'" >
                        <a (click)="goToPage('terms-condition','_blank')" class="password-recovery mx-2">Terms & Conditions</a>
                        <a (click)="goToPage('privacy-policy','_blank')" class="password-recovery mx-2">Privacy Policy</a>
                    </div>
                  </div>
                  </form>
                  </div>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>